export {
  default as mansion,
  ReactComponent as Mansion,
} from '@assets/icons/use-cases/mansion.svg'    
